import React, { Component, SyntheticEvent, useState } from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import MuiPhoneNumber from 'material-ui-phone-number'
import { useFirebaseConnect } from 'react-redux-firebase';
import { useMemo } from 'react';
import parsePhoneNumberFromString, { parsePhoneNumber } from 'libphonenumber-js';
import { addPhoneInvite } from '../actions/sharelink.actions';
import { isMobile } from 'react-device-detect';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const styles = theme => ({
    main: {
      width: 'auto',
      display: 'block', // Fix IE 11 issue.
      marginLeft: theme.spacing.unit * 3,
      marginRight: theme.spacing.unit * 3,
      [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
        width: 400,
        marginLeft: 'auto',
        marginRight: 'auto',
      },
    },
    paper: {
      marginTop: theme.spacing.unit * 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
      margin: theme.spacing.unit,
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing.unit,
    },
    submit: {
      marginTop: theme.spacing.unit * 3,
    },
  })

export const _JoinLinkPortal = (props: any) => {
    const { classes } = props;

    let params = useParams();
    const query = useQuery()
    const dispatch = useDispatch()
    const [isValid, setValid] = useState<boolean>(false)


    const code = useSelector(() => {
        if (query.has('code')) {
            return query.get("code")
        }
        return null
    })

    useEffect(() => {
        if(isMobile && code) {
            //window.location.href = `com.DockPad://join?code=${code}`
            window.open(`com.DockPad://join?code=${code}`,'_blank')

        }
    },[code])

    

    const shareLink: string = useSelector(state => {

        return state.firebase.data[`SHARELINK`]
    })

    useFirebaseConnect(() => {
        return [
            { path: `shareLink/${code}`, storeAs: `SHARELINK` }
        ]
    })

    const projectId = useMemo(() => {

        if (!shareLink) {
            return ""
        }
        return shareLink.projectId
    }, [shareLink])

    /*useFirebaseConnect(() => {
        return [
            { path: `projects/${projectId}`, storeAs: `PROJECT` }
        ]
    })*/

    const project: string = useSelector(state => {

        return state.firebase.data[`PROJECT`]
    })


    const [isSubmitted, setIsSubmitted] = useState<boolean>(false)



    useEffect(() => {
        if (!code || !dispatch) {
            setValid(false)
        } else {
            setValid(true)
        }

    }, [code, dispatch])

    const onJoinClick = () => {
        dispatch(addPhoneInvite({
            projectId,
            phoneNumber,
            name
        }))
        setIsSubmitted(true)
    }

    const [name, setName] = useState<string>("")

    const [phoneNumber, setPhoneNumber] = useState<string>("")


    const onNameChange = (e: SyntheticEvent) => {
        setName(e.target.value)
    }

    const onPhoneChange = (e: string) => {
        const parsePhone = parsePhoneNumberFromString(e, 'US')

        if (parsePhone && parsePhone.isValid()) {
            setPhoneNumber(parsePhone.number.toString())
        }
    }

    const canSubmit = useMemo(() => {
        if (name && name.length > 0 && phoneNumber) {
            return true
        }
        return false
    }, [name, phoneNumber])

    const renderForm = () => {
        return (
            <>
                <Avatar style={{margin: 8,  backgroundColor: 'red'}} >
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Join {project?.name} on DockPad
                </Typography>
                <form style={{width: '100%', marginTop: 8}} noValidate>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Your Name"
                        name="Name"
                        onChange={onNameChange}
                        autoFocus
                    />
                    <MuiPhoneNumber
                        countryCodeEditable={false}
                        inputClass={'fullWidth'}
                        onlyCountries={['us']}
                        placeholder="Placeholder"
                        onChange={onPhoneChange}
                        defaultCountry={'us'}
                    />,

                    <Typography style={{ textAlign: 'center', width: '100%' }}>
                        Please enter your name and number to join
                    </Typography>
                    <Button
                        disabled={!canSubmit}
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        onClick={onJoinClick}
                        style={{margin: 8}}
                    >
                        Join
                    </Button>

                </form>
            </>
        )
    }

    const renderSubmitted = () => {
        return (
            <>
                <Typography component="h1" variant="h5">
                    We sent you a Text Message
                </Typography>

                <Typography style={{ textAlign: 'center', width: '100%' }}>
                        Check you text messages for a download link to download DockPad
                </Typography>
            </>
        )
    }

    if (isValid && projectId) {
        return (
            <main className={classes.main}>

                <div>
                    <CssBaseline />
                    <div style={{marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center'}} >
                        {!isSubmitted && renderForm()}
                        {isSubmitted && renderSubmitted()}
                    </div>

                </div>

            </main>
        )
    } else {
        return (
            <div>
                <p>Invalid Code</p>
            </div>
        )
    }

    return (
        <div>
            <p>hello world</p>
        </div>
    )
}


export const JoinLinkPortal  = withStyles(styles)(_JoinLinkPortal)


// WEBPACK FOOTER //
// ./src/containers/JoinLinkPortal.tsx